<template>
  <a
    :href="link"
    class="link-button"
    :class="`link-button--${design}`"
    @click="$emit('click')"
  >
    <span>{{ buttonFace }}</span>
  </a>
</template>

<script>
export default {
  name: "LinkButton",
  props: {
    buttonFace: {
      type: String,
      default() {
        return 'いますぐ登録'
      }
    },
    link: {
      type: String,
      default: '/subsc/join'
    },
    design: String,
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.link-button {
  width: 100%;
  display: table;
  margin: 0 auto;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  color: white;
  padding: 17px 32px;
  border-radius: 32px;
  cursor: pointer;
  position:relative;
  z-index:1;
  background: $col_def_gradient;

  // design = ghost
  &--ghost {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;
    &::before {
      content: '';
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 2px;
      background: #fff;
      border-radius: 100px;
    }
    span {
      position: relative;
      z-index: 2;
      color: #FF7497;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/LinkButton.vue